module.exports = __webpack_public_path__ + "media/images/loading-82eb7c2c270145d7f427da1c2b8023cd.gif";